/**
 * Ensures a URL ends with a specific version.
 * Concierge environment variables are versioned but Valet is not.
 * This handles that difference when Valet & Concierge use same components.
 */
export const ensureUrlVersion = (url: string, version = 'v1') => {
  return !String(url).endsWith('/v1') ? `${url}/${version}` : url;
};
